<template>
    <el-popover id="searchBox" ref="box" width="35%" placement="bottom-start" trigger="manual" v-model="popVisible" popper-class="topSearch">
        <el-input slot="reference" size="large" @input="searcDebounceHandle" placeholder="请输入内容" v-model="keyword"
            prefix-icon="el-icon-search">
            <span slot="append" @click="search" class="searchBtn">
                搜索
            </span>
        </el-input>
        <div class="content" v-loading="loading">
            <div class="noData" v-if="list.length == 0">无相关搜索结果</div>
            <div v-else>
                <p v-for="(item, index) in list" :key="item + index" @click="detailHanlde(item)">
                    <!-- <span v-html="item.isCloudSceneName"></span> | -->
                    <span v-html="item.equipmentClassification"></span> |
                    <span v-html="item.equipmentNames"></span>
                </p>
            </div>
        </div>
    </el-popover>
</template>
<script>
import { equipList } from "@/api/request"
import { debounce } from '@/utils/index'

const brightKeyword = (val = '', keyword) => {
    if (val.indexOf(keyword) !== -1) {  //判断这个字段中是否包含keyword
        //如果包含的话，就把这个字段中的那一部分进行替换成html字符
        return val.replace(keyword, `<span style="color: #4d6fff">${keyword}</span>`)
    } else {
        return val
    }
}

export default {
    data() {
        return {
            loading: false,
            keyword: '',
            popVisible: false,
            list: []
        }
    },
    watch: {
        '$route.path'() {
            this.popVisible = false
        }
    },
    mounted() {
        if (this.refs && this.refs.box) {
            document.addEventListener('click', e => {
                if (!this.refs.box.contains(e.target)) this.popVisible = false
            })
        }
    },
    methods: {
        searcDebounceHandle() {
            debounce(this.searcHandle(), 300)

        },
        // 查询
        searcHandle() {
            const { keyword } = this
            if (!keyword || keyword == '') {
                this.list = []
                this.popVisible = false
                return
            }
            this.loading = true
            equipList({ isGrounding: 1,status: 1,equipmentName: keyword,pageSize: 20,pageNum: 1 }).then(res => {
                this.loading = false
                const { code, msg, rows } = res || {}
                if (code == 200 && rows.length > 0) {
                    this.list = rows.map(x => ({
                        ...x,
                        isCloudSceneName: brightKeyword(this.dictFilter(x.isCloudScene, 'equipmentClassificationList') || '', keyword),
                        equipmentClassification: brightKeyword(x.equipmentClassification || '', keyword),
                        equipmentNames: brightKeyword(x.equipmentName || '', keyword),

                    }))
                    // this.popVisible = true
                } else {
                    this.list = []
                    // this.popVisible = false
                }
                this.popVisible = true
                if (code !== 200) {
                    this.msgError(msg)
                }

            }).finally(() => {
                this.loading = false
            })
        },
        search(){
            this.popVisible = false
            this.$router.push({ path: '/search', query: { keywords: this.keyword } });
        },
        detailHanlde(item) {
            this.popVisible = false
            this.$router.push({ path: '/search', query: { keywords: item.equipmentName , id: item.id } });
        }
    }
}
</script>
<style>
#searchBox.el-popover {
    min-width: 300px;
}
</style>
<style lang="scss" scoped>
.searchBtn {
    display: block;
    width: 75px;
    height: 100%;
}

.header-search {
    width: 340px;
    height: 40px;
    margin-top: 10px;
    background-color: #f8f8f8;
    position: relative;
    border-radius: 5px;

    ::v-deep .el-input-group__prepend {
        border: none;
        padding: 0 12px;
        min-width: 64px;
        background-color: transparent;

        .el-input__inner {
            padding: 0 12px 0 16px;
            color: #333;
        }
    }

    ::v-deep .el-input__inner {
        background-color: transparent;
        border: none;
    }

    .suffix {
        position: absolute;
        line-height: 40px;
        top: 0;
        bottom: 0;
        right: 0;
        padding-right: 5px;
        cursor: pointer;
        font-size: 18px;
    }
}

.content {
    p {
        cursor: pointer;
        line-height: 30px;
    }
}

.noData {
    height: 105px;
    line-height: 105px;
    text-align: center;
    color: #666;
    font-weight: 500;
    font-size: 16px;
    width: 300px;
}
</style>
  